import "./styles.scss";
import { useState } from "react";
import { toast } from "react-toastify";
import { InfoIcon } from "../icons";

const PUBLIC_BASE = "https://owlmobile.xyz";

const PUBLIC_LINKS = [
  {
    id: "aboutus",
    label: "About Us",
    description: "Trang About công khai (App Store / Google Play).",
    path: "/aboutus",
    url: `${PUBLIC_BASE}/aboutus`,
  },
  {
    id: "policy",
    label: "Privacy Policy",
    description: "Chính sách quyền riêng tư công khai.",
    path: "/policy",
    url: `${PUBLIC_BASE}/policy`,
  },
];

const VALUES = [
  {
    title: "Simplicity",
    body: "Software that works the way people expect, without a learning curve.",
  },
  {
    title: "Privacy",
    body: "We collect only what's needed to run the Service, and explain it plainly.",
  },
  {
    title: "Reliability",
    body: "Apps that are stable and free to use, day after day.",
  },
];

const PRODUCTS = [
  "Podcast English",
  "6 Minute English",
  "Spanish Learning & Podcasts",
  "Daily Learning English",
  "Ringtone Maker",
  "Themes: Icons & Wallpapers",
];

const About = () => {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = async (link) => {
    try {
      await navigator.clipboard.writeText(link.url);
      setCopiedId(link.id);
      toast.success(`Đã copy ${link.label}`);
      window.setTimeout(() => {
        setCopiedId((current) => (current === link.id ? null : current));
      }, 1500);
    } catch (e) {
      toast.error("Không copy được — hãy chọn URL và copy thủ công.");
    }
  };

  return (
    <div className="page-container about-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">About</h1>
          <p className="page-subtitle">
            Thông tin về Owl Studio Inc (MDTeam) — studio đứng sau MD Console.
          </p>
        </div>
      </div>

      <section className="about-panel about-links">
        <div className="about-panel__header">
          <h3 className="about-panel__title">Link công khai</h3>
          <p className="about-panel__subtitle">
            Dùng khi khai báo trên App Store / Google Play — bấm Copy để lấy URL đầy đủ.
          </p>
        </div>
        <div className="about-links__list">
          {PUBLIC_LINKS.map((link) => (
            <div key={link.id} className="about-link-row">
              <div className="about-link-row__meta">
                <div className="about-link-row__label">{link.label}</div>
                <div className="about-link-row__desc">{link.description}</div>
                <a
                  className="about-link-row__url"
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.url}
                </a>
              </div>
              <div className="about-link-row__actions">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => handleCopy(link)}
                >
                  {copiedId === link.id ? "Đã copy" : "Copy"}
                </button>
                <a
                  className="btn btn-outline-secondary btn-sm"
                  href={link.path}
                  target="_blank"
                  rel="noreferrer"
                >
                  Mở
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-hero">
        <div className="about-hero__mark" aria-hidden="true">
          O
        </div>
        <div className="about-hero__copy">
          <div className="about-hero__eyebrow">Owl Studio Inc</div>
          <h2 className="about-hero__title">Operating as MDTeam</h2>
          <p className="about-hero__lead">
            A mobile app studio building simple, useful, and free applications for Android and
            iOS. Small team, focused craft — every app designed to be easy, reliable, and
            helpful in everyday life.
          </p>
        </div>
      </section>

      <div className="about-grid">
        <article className="about-card about-card--accent">
          <div className="form-section-title">Who we are</div>
          <p>
            <strong>Owl Studio Inc</strong> (operating under the name &quot;MDTeam&quot;) builds
            education and everyday utility apps. We care about craftsmanship — apps that feel
            intentional, not bloated.
          </p>
        </article>

        <article className="about-card">
          <div className="form-section-title">Our mission</div>
          <p>
            Useful software shouldn&apos;t be complicated or come at the cost of privacy. We
            design apps that solve real problems — learning a language, catching up on news,
            personalizing your phone — while treating user data and trust with care.
          </p>
        </article>
      </div>

      <section className="about-panel">
        <div className="about-panel__header">
          <h3 className="about-panel__title">What we build</h3>
          <p className="about-panel__subtitle">
            Education and utility apps — refined from real user feedback.
          </p>
        </div>
        <div className="about-products">
          {PRODUCTS.map((name) => (
            <span key={name} className="about-product-chip">
              {name}
            </span>
          ))}
        </div>
      </section>

      <section className="about-panel">
        <div className="about-panel__header">
          <h3 className="about-panel__title">What we value</h3>
        </div>
        <div className="about-values">
          {VALUES.map((item) => (
            <div key={item.title} className="about-value">
              <div className="about-value__icon">
                <InfoIcon width={16} height={16} />
              </div>
              <div>
                <div className="about-value__title">{item.title}</div>
                <div className="about-value__body">{item.body}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-contact">
        <div>
          <div className="form-section-title">Contact</div>
          <p className="about-contact__text">
            Questions, feature requests, or feedback? Reach us at{" "}
            <a href="mailto:mdteam.vnsisolutions@gmail.com">
              mdteam.vnsisolutions@gmail.com
            </a>
            .
          </p>
        </div>
        <a
          className="btn btn-outline-primary"
          href="mailto:mdteam.vnsisolutions@gmail.com"
        >
          Send email
        </a>
      </section>

      <p className="about-footer">© 2026 Owl Studio Inc. All rights reserved.</p>
    </div>
  );
};

export default About;
